import ManagerRepository from 'brandClasses/ManagerRepository';
import Manager from 'coreClasses/Manager';

import SearchProvidersFactory from './SearchProvidersFactory';
import AbstractSearchProvider from './providers/AbstractSearchProvider';
import {ESearchType, ESearchProvider} from './ISearch';

export const DEFAULT_KEY = 'search-page';

/**
 * Represents SearchMgr
 */
class SearchMgr extends Manager {
	private factory: SearchProvidersFactory;
	private searchProviderMap: Map<string, AbstractSearchProvider>;

	/**
	 * @constructor
	 * @param managerRepository {ManagerRepository} - ManagerRepository instance
	 */
	constructor(managerRepository: ManagerRepository) {
		super(managerRepository);

		this.searchProviderMap = new Map();
		this.factory = new SearchProvidersFactory(managerRepository);
	}

	/**
	 * Returns the correct instance of SearchMgr for the given key
	 * @param key {String} - the instance key
	 * @param searchType {ESearchType} - the search type
	 * @param providerId {ESearchProvider} - the search provider id
	 * @returns {AbstractSearchProvider} - the search provider instance
	 */
	getInstance<T extends AbstractSearchProvider>(
		key: string = DEFAULT_KEY,
		searchType: ESearchType = ESearchType.PAGE,
		providerId?: ESearchProvider
	): T {
		if (!providerId) {
			const configurationsMgr = this.managerRepository.getConfigurationsMgr();

			switch (searchType) {
				case ESearchType.PAGE:
					providerId = configurationsMgr
						.get('sitePreferences.searchProvider') as ESearchProvider;

					break;
				case ESearchType.QUICK_SEARCH:
					providerId = configurationsMgr
						.get('sitePreferences.quickSearchProvider') as ESearchProvider;

					break;
				default:
					providerId = ESearchProvider.SFCC;

					break;
			}

			if (!providerId) {
				providerId = ESearchProvider.SFCC;
			}
		}

		const siteId = this.managerRepository.getLocalesMgr().getCurrentCountry().getSiteId();
		const cacheKey = `${key}_${siteId}_${providerId}`;

		if (!this.searchProviderMap.has(cacheKey)) {
			this.searchProviderMap.set(cacheKey, this.factory.create(providerId, key, cacheKey, searchType));
		}

		return this.searchProviderMap.get(cacheKey) as T;
	}
}

export default SearchMgr;
